import { useState, useEffect } from "react";
import "../css/PopUpJetonAcces.css"; 
import { ajouterPraticien, getRPPSInformation } from "./Fonctions_Communications_API";

export default function ModalAjoutPraticien({ 
  etablissement, 
  afficherModalAjoutPraticien, 
  setAfficherModalAjoutPraticien, 
  setShowThankYouModal 
}) {
  const [rppsId, setRppsId] = useState("");
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [infoNouveauPraticien, setInfoNouveauPraticien] = useState(null);

  const handleSubmit = async () => {
    if (!rppsId) {
      setError("Veuillez saisir un RPPS");
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      await ajouterPraticien(etablissement.finess_et, rppsId);
      setAfficherModalAjoutPraticien(false);
      setShowThankYouModal(true);
    } catch (err) {
      setError(err.message || "Erreur lors de l'ajout du praticien");
    } finally {
      setIsLoading(false);
    }
  };




  const handleVerifierPraticien = async () => {
      if (rppsId.trim() !== "") {
        
        await getRPPSInformation(parseInt(rppsId.trim(), 10), setInfoNouveauPraticien);
        
      } else {
        alert("Veuillez entrer un numéro de RPPS.");
      }
    };
    console.log(rppsId)
    console.log(infoNouveauPraticien)
    
    const handleChangeNumeroRPPS = (e) => {
      const value = e.target.value; 
      setRppsId(value);
    };
  
    useEffect(() => {
      if (rppsId.length === 12) {
        handleVerifierPraticien();
      }
      else {
        setInfoNouveauPraticien(null);
      }
    }, [rppsId]);



  if (!afficherModalAjoutPraticien) return null;

  return (
    <div className="jetonacces-overlay">
      <div className="jetonacces-container">
        <h2 className="jetonacces-title">Ajouter un praticien</h2>
        
        <div className="jetonacces-info-group">
          <p><strong>Établissement :</strong> {etablissement.nom || etablissement.rs}</p>
          <p><strong>FINESS :</strong> {etablissement.finess_et}</p>
        </div>

        <input
          type="number"
          placeholder="Entrez le RPPS du praticien"
          value={rppsId}
          onChange={handleChangeNumeroRPPS}
          className="jetonacces-input"
          style={{marginTop:'20px'}}
          maxLength={12}
        />
        

        {infoNouveauPraticien && (
            <div className="etablissement-info">
              <h3>Praticien trouvé :</h3>
              
              <div className="etablissement-detail">
                <p>{infoNouveauPraticien.nom}</p>
              </div>

              <div className="etablissement-detail">
                <p>{infoNouveauPraticien.prenom}</p>
              </div>

              <div className="etablissement-detail">
                <img src={`logos_marianne_PS/${infoNouveauPraticien.profession}.png`} alt="Ville" />
                <p>{infoNouveauPraticien.profession}</p>
              </div>
            </div>
          )}

        <div className="jetonacces-boutons">
          <button 
            onClick={() => setAfficherModalAjoutPraticien(false)} 
            className="jetonacces-bouton cancel"
          >
            Annuler
          </button>
          <button 
            onClick={handleSubmit} 
            className="jetonacces-bouton submit"
            disabled={isLoading}
          >
            {isLoading ? "En cours..." : "Valider"}
          </button>
        </div>
      </div>
    </div>
  );
}